import { arrayBufferDownload, arrayBufferDownloadExcel, downloadCSV } from "../../../../utils/download";
import { decorateEmptyGridValues, setColumnDefaultExtraProps } from "../../../../utils/table/gridUtils";
import { DATE_STRATEGY } from "../../../../utils/date";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_LIST, 
  TOAST, 
  FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_INIT,
  FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_DETAIL,
  EXPORT_RESERVATIONS_PREPAIDBOOKINGSREPORT,
  CREATE_RESERVATIONS_PREPAIDBOOKINGSREPORT,
  EDIT_RESERVATIONS_PREPAIDBOOKINGSREPORT,
  INIT_CREATE_RESERVATIONS_PREPAIDBOOKINGSREPORT_SCREEN,
  RESERVATIONS_PREPAIDBOOKINGSREPORTDD,
  RESERVATIONS_PREPAIDBOOKINGSREPORTDELETE,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  SET_RESERVATION_PREPAIDBOOKING_FILTERS,
  CLEAR_RESERVATION_PREPAIDBOOKING_FILTERS,
  SET_PREPAIDBOOKING_TABLE_COLUMN_FILTERS,
  CLEAR_PREPAIDBOOKING_TABLE_COLUMN_FILTERS
} from "../../../types/Reservations/PrepaidBookingsReport.type";
import { getCurrentAndThreeDaysLater } from "../../../../utils";



  const formFieldValueMap = {
    id:null,
    status:1,
    title:"",
    paymentStatus:"",
    reasonCancel:"",
    driverInfo:{},
    itinerary:{},
    note:"",
    renterAmountDetails:{},
    renterVehicleInfo:{},
    reservationStatus:""
  };
  const { currentDate, threeDaysLater } = getCurrentAndThreeDaysLater();
  const INITIAL_STATE = {
    ReservationsPrepaidBookingsReportListview: [],
    ReservationsPrepaidBookingsReportDD:[],
    isReservationsPrepaidBookingsReportDDSuccess: false,
    isReservationsPrepaidBookingsReportDDError: false,
    isLoading: false,
    error: null,
    formFieldValueMap,
    isReservationsPrepaidBookingsReportCreateSuccess: false,
    isReservationsPrepaidBookingsReportCreateError: false,
    isReservationsPrepaidBookingsReportDetailSuccess: false,
    isReservationsPrepaidBookingsReportDetailError: false,
    isReservationsPrepaidBookingsReportEditSuccess: false,
    isReservationsPrepaidBookingsReportEditError: false,
    isReservationsPrepaidBookingsReportExportSuccess: false,
    isReservationsPrepaidBookingsReportExportError: false,
    isUploadImageSuccess: false,
    isUploadImageError: false,
    imageUploadResponse:null,
    isReservationsPrepaidBookingsReportDeleteSuccess: false,
    isReservationsPrepaidBookingsReportDeleteError: false,
    reservationPrepaidBookingsFilters: {
    endDate: threeDaysLater,
    startDate: currentDate,
    location: "",
    network: "",
  },
  tableColumnFilters: {},
  };
  
  const tranformToGridView = (data) => {
    const rows = Array.isArray(data) && data.map((item) => {
      const {
        id,
        ref,
        networkBookingNo,
        networkTitle,
        locationTitle,
        name,
        vehicle,
        bookingDate,
        pickup,
        dropoff,
        currencyCode,
        totalAmount,
        paymentStatus,
        status,
        days,
        rateType
      } = item;
  
      const transformedValues = {
        id,
        ref,
        networkBookingNo,
        networkTitle,
        locationTitle,
        name,
        vehicle,
        bookingDate,
        pickup,
        dropoff,
        currencyCode,
        totalAmount,
        paymentStatus,
        status,
        days,
        rateType
      };
      const decoratedValues = {};
      Object.keys(transformedValues).forEach((key) => {
        decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
      });
      return decoratedValues;
    });
  
    const columns = [
      {
        colLabel: "ID",
        dataKey: "id",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Res #",
        dataKey: "ref",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Network Booking",
        dataKey: "networkBookingNo",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Network",
        dataKey: "networkTitle",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      
     
      {
        colLabel: "Location",
        dataKey: "locationTitle",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Vehicle",
        dataKey: "vehicle",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Booking Date",
        dataKey: "bookingDate",
        extraProps: {
          isSortable: true,
          isDateField: true,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Select date",
          strategy: DATE_STRATEGY.DATE_TIME_ISO_AMPM
        }
      },
      {
        colLabel: "Pickup Date",
        dataKey: "pickup",
        extraProps: {
          isSortable: true,
          isDateField: true,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Select date",
          strategy: DATE_STRATEGY.DATE_TIME_ISO_AMPM
        }
      },
      {
        colLabel: "Dropoff Date",
        dataKey: "dropoff",
        extraProps: {
          isSortable: true,
          isDateField: true,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Select date",
          strategy: DATE_STRATEGY.DATE_TIME_ISO_AMPM
        }
      },
      {
        colLabel: "Days",
        dataKey: "days",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Total",
        dataKey: "totalAmount",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Currency",
        dataKey: "currencyCode",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Name",
        dataKey: "name",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Payment Status",
        dataKey: "paymentStatus",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Rate Type",
        dataKey: "rateType",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      
      {
        colLabel: "Status",
        dataKey: "status",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      }
    ];
  
    return {
      datas: { columns, rows },
    };
  };

  export const ReservationsPrepaidBookingsReportReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_INIT:
        return { 
          ...INITIAL_STATE, 
          isLoadingPage: true, 
          reservationPrepaidBookingsFilters: state.reservationPrepaidBookingsFilters,
          tableColumnFilters: state.tableColumnFilters,
          // Preserve list data and pagination when filters exist (coming back from detail view)
          ReservationsPrepaidBookingsReportListview: state.reservationPrepaidBookingsFilters?.location?.length > 0 
            ? state.ReservationsPrepaidBookingsReportListview 
            : INITIAL_STATE.ReservationsPrepaidBookingsReportListview,
          paginationInfo: state.reservationPrepaidBookingsFilters?.location?.length > 0 
            ? state.paginationInfo 
            : INITIAL_STATE.paginationInfo,
        };
      case FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_DETAIL.START:
      case EXPORT_RESERVATIONS_PREPAIDBOOKINGSREPORT.START:
        case UPLOAD_IMAGE.START:
      case FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_LIST.START:
      case CREATE_RESERVATIONS_PREPAIDBOOKINGSREPORT.START:
        case RESERVATIONS_PREPAIDBOOKINGSREPORTDELETE.START:
        case EDIT_RESERVATIONS_PREPAIDBOOKINGSREPORT.START:
          case RESERVATIONS_PREPAIDBOOKINGSREPORTDD.START:
        return { ...state, isLoading: true };
  
      case FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_LIST.SUCCESS: {
        const { page, data } = action.payload?.data;
        let resetState = {
          ReservationsPrepaidBookingsReportListview: [],
          paginationInfo:null,
          error: null,
          isLoading: false,
          isLoadingPage: false,
          isPageLevelError: false,
          isReservationsPrepaidBookingsReportCreateSuccess: false,
          isReservationsPrepaidBookingsReportCreateError: false,
        };
        if (!data) {
          return { 
            ...resetState, 
            reservationPrepaidBookingsFilters: state.reservationPrepaidBookingsFilters,
            tableColumnFilters: state.tableColumnFilters,
          };
        }
        const { number, size, totalElements, totalPages } = page;
        const { datas } = tranformToGridView(data);
        return {
          ...resetState,
          reservationPrepaidBookingsFilters: state.reservationPrepaidBookingsFilters,
          tableColumnFilters: state.tableColumnFilters,
          ReservationsPrepaidBookingsReportListview: datas,
          paginationInfo: {
            pageSize: size ? size : 0,
            totalRecords: totalElements,
            totalPages: totalPages,
            pageNumber: number ? number : 0,
          },
        };
      }
      case FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_LIST.ERROR: {
        const { error } = action.payload;
  
        return {
          ...state,
          ReservationsPrepaidBookingsReportListview: [],
          isLoading: false,
          isLoadingPage: false,
          error,
          isPageLevelError: true,
          isReservationsPrepaidBookingsReportDeletionSuccess: false,
          isReservationsPrepaidBookingsReportDeletionError: false,
          shouldOpenDeleteConfirmationPopup: false,
        };
      }

    case FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
              temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isReservationsPrepaidBookingsReportDetailSuccess: true,
      };
    }
    case FETCH_RESERVATIONS_PREPAIDBOOKINGSREPORT_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isReservationsPrepaidBookingsReportDetailSuccess: false,
        isReservationsPrepaidBookingsReportDetailError: true,
      };
    }

    //DD
    case RESERVATIONS_PREPAIDBOOKINGSREPORTDD.SUCCESS: {
      const temp = action.payload;
 
      return {
        ...state,
        isLoading: false,
        ReservationsPrepaidBookingsReportDD:temp,
        isReservationsPrepaidBookingsReportDDSuccess: true,
        isReservationsPrepaidBookingsReportDDError: false,
      };
    }
    case RESERVATIONS_PREPAIDBOOKINGSREPORTDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isReservationsPrepaidBookingsReportDDSuccess: false,
        isReservationsPrepaidBookingsReportDDError: true,
      };
    }
    //END DD
//DELETE

case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY: {
  const shouldOpenDeleteConfirmationPopup = action.payload;
  return {
    ...state,
    shouldOpenDeleteConfirmationPopup,
    isReservationsPrepaidBookingsReportDeleteSuccess: false,
    isReservationsPrepaidBookingsReportDeleteError: false,
  };
}
case RESERVATIONS_PREPAIDBOOKINGSREPORTDELETE.SUCCESS: {
  const temp = action.payload;

  return {
    ...state,
    isLoading: false,
    isReservationsPrepaidBookingsReportDeleteSuccess: true,
    isReservationsPrepaidBookingsReportDeleteError: false,
    shouldOpenDeleteConfirmationPopup: false,
  };
}
case RESERVATIONS_PREPAIDBOOKINGSREPORTDELETE.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    error,
    isReservationsPrepaidBookingsReportDeleteSuccess: false,
    isReservationsPrepaidBookingsReportDeleteError: true,
    shouldOpenDeleteConfirmationPopup: false,
  };
}
//END DD   
    
// UPLOAD_IMAGE Start
case UPLOAD_IMAGE.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isUploadImageSuccess: false,
    isUploadImageError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case UPLOAD_IMAGE.SUCCESS: {
  const  {data}  = action.payload;
   return {
    ...state,
    imageUploadResponse:data,
    isUploadImageSuccess: true,
    isUploadImageError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// UPLOAD_IMAGE End

// Export Start
case EXPORT_RESERVATIONS_PREPAIDBOOKINGSREPORT.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isReservationsPrepaidBookingsReportExportSuccess: false,
    isReservationsPrepaidBookingsReportExportError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case EXPORT_RESERVATIONS_PREPAIDBOOKINGSREPORT.SUCCESS: {
  const  data  = action.payload;
  arrayBufferDownloadExcel(data,"prepaid-bookings-report.xls");
   return {
    ...state,
    isReservationsPrepaidBookingsReportExportSuccess: true,
    isReservationsPrepaidBookingsReportExportError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// Export End

// EDIT
case EDIT_RESERVATIONS_PREPAIDBOOKINGSREPORT.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isReservationsPrepaidBookingsReportEditSuccess: false,
    isReservationsPrepaidBookingsReportEditError: true,
  };
}

case EDIT_RESERVATIONS_PREPAIDBOOKINGSREPORT.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isReservationsPrepaidBookingsReportEditSuccess: true,
    isReservationsPrepaidBookingsReportEditError: false,
  };
}

// EDIT END

// Create
case INIT_CREATE_RESERVATIONS_PREPAIDBOOKINGSREPORT_SCREEN: {
  return { ...INITIAL_STATE, reservationPrepaidBookingsFilters: state.reservationPrepaidBookingsFilters };
}

case CREATE_RESERVATIONS_PREPAIDBOOKINGSREPORT.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isReservationsPrepaidBookingsReportCreateSuccess: false,
    isReservationsPrepaidBookingsReportCreateError: true,
  };
}
case CREATE_RESERVATIONS_PREPAIDBOOKINGSREPORT.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isReservationsPrepaidBookingsReportCreateSuccess: true,
    isReservationsPrepaidBookingsReportCreateError: false,
  };
}

    case SET_RESERVATION_PREPAIDBOOKING_FILTERS: {
      return {
        ...state,
        reservationPrepaidBookingsFilters: action.payload.filters,
      };
    }

        case CLEAR_RESERVATION_PREPAIDBOOKING_FILTERS: {
          const { currentDate: newCurrentDate, threeDaysLater: newThreeDaysLater } = getCurrentAndThreeDaysLater();
          return {
            ...state,
            reservationPrepaidBookingsFilters: {
              endDate: newThreeDaysLater,
              startDate: newCurrentDate,
              location: "",
              network: "",
            },
          };
        }

    case SET_PREPAIDBOOKING_TABLE_COLUMN_FILTERS: {
      return {
        ...state,
        tableColumnFilters: action.payload.filters,
      };
    }

    case CLEAR_PREPAIDBOOKING_TABLE_COLUMN_FILTERS: {
      return {
        ...state,
        tableColumnFilters: {},
      };
    }

//End
  

      case TOAST.RESET: {
        return {
          ...state,
          isReservationsPrepaidBookingsReportCreateSuccess: false,
          isReservationsPrepaidBookingsReportCreateError: false,
          isReservationsPrepaidBookingsReportEditError: false,
          isReservationsPrepaidBookingsReportEditSuccess: false,
          isReservationsPrepaidBookingsReportDetailError: false
        };
      }
      default:
        return state;
    }
  };
  